import { dataFeed } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFeed = /*#__PURE__*/createIcon(dataFeed)
export default IconFeed
